<script lang="ts">
    
    import type { CoordinatesDto, TargetDto } from "../../global";
    import { userBearing } from "../../Services/compass";
    import { followMode } from "../../Services/follow";
    import { currentTarget } from "../../Services/game";
    import { calcBearing, playerPosition } from "../../Services/geolocation";

    let bearing = 0;

    $: updateBearing($currentTarget, $playerPosition, $userBearing, $followMode);

    function updateBearing(target: TargetDto, playerPosition: CoordinatesDto, userBearing: number, followMode: boolean): void {
        if (!target || !playerPosition || followMode) {
            bearing = 0;
            return;
        }
        bearing = calcBearing(playerPosition, target.position) - userBearing;
    }

</script>

<div class="compass" on:click style="transform: rotate({bearing}deg);">
    <img class="compass-image" src="/images/compass.svg" alt="">
</div>

<style lang="scss">

    $size: 75px;

    .compass {
        width: $size;
        height: $size;
        border-radius: 50%;
        filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.25));
    }

    .compass-image {
        width: 100%;
        height: 100%;
    }

</style>